import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8500';


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const audioService = {
  generateAudio: async (data) => {
    try {
      const response = await api.post('/generate', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Failed to generate audio');
    }
  },

  getStreamUrl: (fileId) => `${API_BASE_URL}/stream/${fileId}`
};